angular = require('angular')
class EditorService
  @$inject: ["$uibModal"]
  constructor: (@modal)->

  edit: (options)->
    {template} = options
    instance = @modal.open
      template: template ? require("./index.pug")
      controller: EditorServiceCtrl             
      controllerAs: '$ctrl'
      windowClass: 'modal-editor'
      resolve: 
        options: ()->
          return options?={}

    return instance.result

class EditorServiceCtrl
  constructor: ($uibModalInstance, options)->
    @instance = $uibModalInstance  
    {@title="Edit Record", @source, @schema} = options    
    @dirty = angular.copy(@source)
    @date = new Date()
  confirm: ()->
    angular.copy(@dirty, @source)
    @instance.close(@source)
  cancel: ()->
    @instance.dismiss "cancelled"

module.exports = EditorService


// WEBPACK FOOTER //
// ./src/common/editor/modal/index.coffee